import CommonContent from './Common';

class OptionViewDetailContents extends CommonContent {
  /* eslint-disable-next-line */
  constructor() {
    super();
  }

  get contentImages() {
    return this.htDealContentInfo.contentImages || {};
  }

  get columnSize() {
    return this.htDealContentInfo.dealOptionViewDetail.columnSize || '';
  }

  get imageList() {
    const imageList =
      (TMON.oApp.getStorage('splitContent') &&
        TMON.oApp.getStorage('splitContent').data.dealOptionViewDetail
          .imageList) ||
      [];
    return imageList;
  }

  get hasOptions() {
    /* \\ UI 노출 여부와 UI 노출을 위한 데이터를 저장 */
    return (
      TMON.oApp.htStorage.optionInfo &&
      TMON.oApp.htStorage.optionInfo.options &&
      TMON.oApp.htStorage.optionInfo.options[0] &&
      TMON.oApp.htStorage.optionInfo.options[0].length > 0
    );
  }

  initHTML() {
    this.initData();
    let html = '';
    html += this.makeVideoContent();
    html += this.makeIntro();
    html += this.makeOptionDetailLook();
    html += this.bOptionDeal
      ? `<div class="btn_deal_wrap">${this.makeAllButton()}</div>`
      : "";
    return html;
  }

  updateHTML() {
    /* 자세히보기 옵션목록 - OPTION_VIEW_DETAIL 타입 */
    if (this.bDetailviewAvailable && !this.bOptionDeal) {
      const sHTML = `<div class="review_opt ${
        this.bShowAdditionalButton ? 'button_show' : ''
      } r5"><ul class="colm${this.columnSize}"></ul></div>`;
      const appendHtml = this.imageList.map((item, idx) =>
        this.getOptionViewDetailOptionItemHtml(
          item,
          idx,
          this.hasOptions &&
            this.isOptionViewDetailItemSoldout(
              TMON.oApp.htStorage.optionInfo.options[0],
              idx
            )
        )
      );
      this.initReviewOpt(`.review_opt.r5 .colm${this.columnSize}`, sHTML);
      this.welWrapper
        .find(`.review_opt.r5 .colm${this.columnSize}`)
        .append(appendHtml);
    }
    /* 자세히보기 상세이미지 - OPTION_VIEW_DETAIL 타입 / 단일 */
    if (this.bOptionDeal && this.bDetailviewAvailable) {
      let html = "";
      if (this.imageList[this.nOptionDealIndex]) {
        html = this.getOptionViewDetailItemHtml(
          `${this.PREFIX_IMAGE_URL}${
            this.imageList[this.nOptionDealIndex].optionDetailImg
          }`,
          this.nOptionDealIndex,
          true
        );
      } else {
        html = `<div class="no-image d"><div class="no-image-inner"><i></i></div></div>`;
      }
      this.welWrapper.append(html);
    }
    // 옵션 이미지 렌더링 후 여행 체크리스트, 마켓 이미지 렌더링
    let sHtml = '';
    sHtml += this.makeTravelCheckList();
    sHtml += this.makeMarketImage();
    this.welWrapper.append(sHtml);
  }

  updateDetailImageHTML(nDetailImageSplitIdx) {
    if (!this.bDetailviewAvailable) return;
    const nDetailImageStartIdx = nDetailImageSplitIdx - 50;
    const updateImageList = this.imageList.slice(nDetailImageStartIdx, nDetailImageSplitIdx);
    this.updateOptionViewDetailImage(updateImageList, nDetailImageStartIdx);
  }

  initData() {
    this.bShowAdditionalButton = false;
  }

  /**
   * OptionViewDetail 메인 이미지 그리기
   */
  makeIntro() {
    // 메인 이미지(대표이미지) data
    const { productMainImage = '' } = this.contentImages;
    return productMainImage
      ? `${this.getLazyImgHtml(productMainImage, true)}`
      : '';
  }

  makeDetailOptionList(imageList) {
    return !this.bOptionDeal &&
      this.bDetailviewAvailable &&
      imageList.length > 0
      ? `
      <div class="review_opt ${
        this.bShowAdditionalButton ? 'button_show' : ''
      } r5">
          <ul class="colm${this.columnSize}">
          ${imageList
            .map((item, idx) =>
              this.getOptionViewDetailOptionItemHtml(
                item,
                idx,
                this.hasOptions &&
                  this.isOptionViewDetailItemSoldout(
                    TMON.oApp.htStorage.optionInfo.options[0],
                    idx
                  )
              )
            )
            .join('')}</ul>
                    </div>`
      : '';
  }

  makeMarketImage() {
    const { marketingImage = '' } = this.contentImages;
    const { viewMarketingImage = true } = this.contentInfo;
    return viewMarketingImage && marketingImage
      ? this.getLazyImgHtml(marketingImage, true)
      : '';
  }

  updateOptionViewDetailImage(updateImageList, nDetailImageStartIdx) {
    this.initReviewOpt('.review_opt.r10', '<div class="review_opt r10"></div>');
    this.welWrapper
      .find('.review_opt.r10')
      .append(
        updateImageList
          .map((item, idx) =>
            item.optionDetailImg
              ? this.getOptionViewDetailItemHtml(
                  `${this.PREFIX_IMAGE_URL}${item.optionDetailImg}`,
                  idx + nDetailImageStartIdx,
                  true
                )
              : '<div class="no-image d"><div class="no-image-inner"><i></i></div></div>'
          )
          .join('')
      );
  }

  /**
   * 자세히보기 옵션 목록의 옵션 - OPTION_VIEW_DETAIL 타입
   */
  getOptionViewDetailOptionItemHtml(item, idx, isSoldOut = false) {
    if (!Object.keys(item).length) return null;

    const originalSrc = `${this.PREFIX_IMAGE_URL}${item.optionImg}`;
    const finalImg = this.getLazyOriginalImgHtml(originalSrc, true);

    return `<li id="review_opt${item.imageOrder}" ${
      isSoldOut ? 'class="soldout"' : ''
    } data-role="op">
                <a href="#scene=scene-optiondetail&order_no=${idx}" data-order="${idx}" data-role="openOptionDeal" data-tlarea="${
      this.tlCode.area.openOptionDeal
    }" data-tlord="1" class="optiondetail_clickable">${finalImg}</a>
        ${
          this.bShowAdditionalButton
            ? `
            <div class="item_button">
                <a href="#scene=scene-optiondetail&order_no=${idx}" class="item_button_view" data-tlarea="TESTDDO" data-tlord="1" data-role="openOptionDeal" data-order="${idx}">상세보기</a>
                <button class="item_button_option" type="button" data-tlarea="TESTDDO" data-tlord="2" data-role="옵션선택"><i></i>옵션선택</button>
            </div>
        `
            : ''
        }
    </li>`;
  }

  /**
   * 자세히보기 상세이미지 - OPTION_VIEW_DETAIL 타입
   */
  getOptionViewDetailItemHtml(src, idx, bShow) {
    return `<img class="unload contents-options" data-idx="${idx}" src="${
      this.PREFIX_IMAGE_URL
    }/static2/img/blank.png" data-src="${src}" role="presentation"${
      !bShow ? ' style="display:none"' : ''
    }>`;
  }

  /*
   * OPTION_VIEW_DETAIL 타입 / 전체일 때 옵션 매진 여부를 반환
   * @param aChildNodes : htOption.childNodes 1 depth
   * @param index : Option Index
   */
  isOptionViewDetailItemSoldout = (aChildNodes, index) => {
    if (!aChildNodes[index] || !aChildNodes[index].dealMax) return false;
    return aChildNodes[index].dealMax.soldOut;
  };

}

export default OptionViewDetailContents;
